<template>
  <div>
    <h3>Histogram type</h3>
    <p>
      For each histogram selected, the results may be presented in two forms:
    </p>
    <ul>
      <li>
        <b>Occurence histogram</b>: presents the amount of data within the
        interval of each bin.
      </li>
      <li>
        <b>Cumulative histogram</b>: presents the amount of data within the
        interval from the first bin (smallest value) up until the current one
        (inclusive).
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipHistogramsSettings'
}
</script>
